<template>
  <div
    id="FormModal"
    :class="{ active: modalActive }"
    @click.prevent="
      (e) => {
        if (e.target === e.currentTarget) $emit('modalHide', 'hide');
      }
    "
  >
    <div class="container">
      <div
        class="close"
        @click.prevent="(e) => $emit('modalHide', 'hide')"
        v-if="!success"
      >
        <img src="@/assets/images/close.svg" />
      </div>
      <div class="content">
        <div v-if="!success" class="header">
          <h1 class="title">MEMBERSHIP MEANS MORE IN ISLES NATION</h1>
          <h3>
            Sign up to learn how to unlock the best-in-class ticket pricing,
            savings on parking and concessions, and exclusive team access.
          </h3>
        </div>
        <div v-if="success" class="success" :class="[success ? 'active' : '']">
          <img src="~images/logo/logo-with-year.svg" alt="" />
          <p>
            Thank you for your submission. A New York Islanders representative
            will be in touch with you shortly.
          </p>
          <button @click.prevent="(e) => $emit('modalHide', 'hide')">
            Close
          </button>
        </div>
        <form
          :class="{ hide: success }"
          action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D4600000102aZ"
          method="POST"
        >
          <input type="hidden" name="oid" value="00D4600000102aZ" />
          <input
            type="hidden"
            name="retURL"
            value="https://islanders.vipfanportal.com/2025sales/?submission=true"
          />

          <!--  ----------------------------------------------------------------------  -->
          <!--  NOTE: These fields are optional debugging elements. Please uncomment    -->
          <!--  these lines if you wish to test in debug mode.                          -->
          <!--  <input type="hidden" name="debug" value=1>                              -->
          <!--  <input type="hidden" name="debugEmail"                                  -->
          <!--  value="nyislanders@marketing.leapevent.tech">                           -->
          <!--  ----------------------------------------------------------------------  -->

          <div class="fields">
            <div class="field">
              <label for="first_name">First Name</label
              ><input
                id="first_name"
                maxlength="40"
                name="first_name"
                size="20"
                type="text"
                placeholder="First Name"
                required
              />
            </div>
            <div class="field">
              <label for="last_name">Last Name</label
              ><input
                id="last_name"
                maxlength="80"
                name="last_name"
                size="20"
                type="text"
                placeholder="Last Name"
                required
              />
            </div>
            <div class="field">
              <label for="email">Email</label
              ><input
                id="email"
                maxlength="80"
                name="email"
                size="20"
                type="email"
                placeholder="Email"
                required
              />
            </div>
            <div class="field">
              <label for="phone">Phone</label
              ><input
                id="phone"
                maxlength="40"
                name="phone"
                size="20"
                type="tel"
                placeholder="111-111-1111"
                required
                pattern="\(?[0-9]{3}\)?[ -.]?[0-9]{3}[ -.]?[0-9]{4}"
                title="Please enter a valid phone number"
              />
            </div>
            <div class="field">
              <label for="zip">Zip</label
              ><input
                id="zip"
                maxlength="20"
                name="zip"
                size="20"
                type="text"
                placeholder="12345"
                required
              />
            </div>

            <!-- GA ID: -->
            <input
              id="00N4p00000G9NIA"
              maxlength="201"
              name="00N4p00000G9NIA"
              size="20"
              type="hidden"
            />

            <!-- Web Form Campaign: -->
            <input
              id="utm_campaign"
              maxlength="100"
              name="00N4p00000G9NIF"
              size="20"
              type="hidden"
            />

            <!-- Web Form Medium: -->
            <input
              id="utm_medium"
              maxlength="100"
              name="00N4p00000G9NIK"
              size="20"
              type="hidden"
            />

            <!-- Web Form Content: -->
            <input
              id="utm_content"
              maxlength="201"
              name="00N4p00000G9RcE"
              size="20"
              type="hidden"
            />

            <!-- Web Form Source: -->
            <input
              id="utm_source"
              maxlength="100"
              name="00N4p00000G9NI5"
              size="20"
              type="hidden"
            />

            <input
              id="00N4p00000G2PrA"
              maxlength="255"
              name="00N4p00000G2PrA"
              size="20"
              type="hidden"
              value="true"
            />

            <input
              id="00N4p00000G9ONk"
              maxlength="50"
              name="00N4p00000G9ONk"
              value="New Business Page 25-26"
              size="20"
              type="hidden"
            />

            <input id="rep" name="00N4p00000FlhSn" type="hidden" value="True" />

            <div class="submitWrapper">
              <input type="submit" @click.stop name="submit" />
            </div>

            <p>
              By submitting this form, I agree to receive phone calls and emails
              from account managers regarding ticket memberships, as well as
              email marketing communications from the New York Islanders and UBS
              Arena.
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
// import axios from "axios";

export default {
  name: "formModal",
  props: ["modalActive"],
  emits: ["modalHide"],

  data() {
    return {
      success: false,
      // web_form_product: '',
      output: {
        // utm_source: "",
        // utm_medium: "",
        // utm_campaign: "",
        // // utm_term : '',
        // utm_content: "",
        // // web_form_product: '',
        // first_name: "",
        // last_name: "",
        // email: "",
        // zip: "",
        // // phone : '',
        // rep: "",
      },
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams.values);
    this.success =
      urlParams.has("submission") && urlParams.get("submission") === "true";

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    var gaUserId = document.cookie
      .match(/_ga=(.+?);/)[1]
      .split(".")
      .slice(-2)
      .join(".");
    document.getElementById("00N4p00000G9NIA").value = gaUserId;
    console.log(gaUserId);

    const parseGET = function (param) {
      var searchStr = document.location.search;
      try {
        var match = searchStr.match("[?&]" + param + "=([^&]+)");
        if (match) {
          var result = match[1];
          result = result.replace(/\+/g, "%20");
          result = decodeURIComponent(result);
          return result;
        } else {
          return "";
        }
      } catch (e) {
        return "";
      }
    };

    document.getElementById("utm_source").value = parseGET("utm_source");
    document.getElementById("utm_medium").value = parseGET("utm_medium");
    document.getElementById("utm_campaign").value = parseGET("utm_campaign");
    // document.getElementById("utm_term").value = parseGET("utm_term") ?  parseGET("utm_term")  : '';
    document.getElementById("utm_content").value = parseGET("utm_content");
  },
  methods: {
    submitForm() {
      this.success = true;
    },
    getFormValues(submitEvent) {
      //   this.output.utm_source = submitEvent.target.elements.utm_source.value;
      //   this.output.utm_medium = submitEvent.target.elements.utm_medium.value;
      //   this.output.utm_campaign = submitEvent.target.elements.utm_campaign.value;
      //   // this.output.utm_term =submitEvent.target.elements.utm_term.value
      //   this.output.utm_content = submitEvent.target.elements.utm_content.value;
      //   this.output.first_name = submitEvent.target.elements.first_name.value;
      //   this.output.last_name = submitEvent.target.elements.last_name.value;
      //   this.output.email = submitEvent.target.elements.email.value;
      //   this.output.zip = submitEvent.target.elements.zip.value;
      //   //   this.output.phone =submitEvent.target.elements.phone.value
      //   this.output.rep = submitEvent.target.elements.rep.value;
      //   console.log(this.output);
    },
  },
};
</script>

<style lang="scss" scoped>
#FormModal {
  background: rgba(0, 0, 0, 0.74);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  max-height: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  z-index: 99;
  &.active {
    max-height: calc(var(--vh, 1vh) * 100);
    opacity: 1;
    z-index: 1000;
    transition: all 0.5s ease-in-out;
  }
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    // display: flex;
    // justify-content: center;
    // align-items: center;
    height: auto;
    width: min-content;
    // position: relative;
    @include media-breakpoint-down(md) {
      width: 95%;
    }
  }
  .close {
    position: absolute;
    top: 24px;
    right: 36px;
    height: fit-content;
    width: fit-content;
    cursor: pointer;
    z-index: 1;
  }
  .closeMobile {
    top: 3%;
    z-index: 1;
  }
  .content {
    position: relative;

    width: 880px;
    max-width: 100%;
    background-image: url("~images/form-bg.jpg");
    background-size: cover;
    background-position: top left;
    max-height: 91vh;
    overflow-y: auto;
    box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.5);
    padding: 70px 124px 20px;
    @include media-breakpoint-down(md) {
      padding: 50px 30px;
      overflow-x: scroll;
    }

    form {
      margin-top: 32px;
      margin-bottom: 45px;

      &.hide {
        display: none;
      }

      .fields {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        @include media-breakpoint-down(md) {
          flex-direction: column;
        }

        .field {
          max-width: 50%;
          flex: 0 0 50%;
          padding: 0 11px;

          @include media-breakpoint-down(md) {
            max-width: 100%;
            flex: 0 0 100%;
          }

          label {
            font-family: Prompt;
            color: var(--White, #fff);
            font-size: 14px;
            font-style: italic;
            font-weight: 700;
            line-height: normal;
            text-transform: uppercase;
            display: block;
            margin: 0 0 12px;
          }

          input {
            border: none;
            height: 62px;
            line-height: 62px;
            width: 100% !important;
            background: var(--shade, #f1f1f1);
            box-sizing: border-box;
            padding: 0 16px;
            color: var(--Blue, #00468b);
            font-family: "Prompt";
            font-size: 14px;
            font-style: italic;
            font-weight: 700;
            text-transform: uppercase;
            border-radius: 0;
            margin-bottom: 25px;
          }
        }

        .submitWrapper {
          flex-basis: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          input[type="submit"] {
            display: inline-block;
            text-transform: uppercase;
            text-align: center;
            width: auto;
            height: auto;
            font-family: Prompt;
            padding: 14px 24px 10px;
            font-size: 18px;
            line-height: normal;
            text-transform: uppercase;
            transition: all 0.2s linear;
            border-radius: 0;
            border: none;
            outline: none;
            transform: scale(1);
            background-color: transparent;
            font-weight: 700;
            color: white;
            border: 2px solid #f16924;
            cursor: pointer;
            margin: 20px auto 25px;

            &:hover {
              border: 2px solid white;
              background-color: #f16924;
            }
          }
        }

        p {
          text-align: center;
          font-family: Prompt;
          color: #fff;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }

    .header {
      .title {
        color: white;
        text-transform: uppercase;
        margin-bottom: 0.5rem;
        font-family: "Prompt";
        font-size: 40px;
        text-align: center;
        line-height: 1;
        font-weight: 900;

        @include media-breakpoint-down(md) {
          font-size: 24px;
        }
      }
      h3 {
        color: white;
        margin-bottom: 0.5rem;
        font-family: "Prompt";
        font-size: 24px;
        text-align: center;
        line-height: 1;
        font-weight: 700;

        @include media-breakpoint-down(md) {
          font-size: 16px;
        }
      }
    }

    .dropdown {
      position: relative;
      height: 46px;
      width: 288px;
      padding: 0 18.5px 0 23px;
      background: #ffffff;
      border: 1px solid #b4b4b4;
      margin: 0 auto;
      .display {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        width: 100%;
        cursor: pointer;
        span {
          font-family: "GeogrotesqueSharp-Md";
          font-size: 13px;
          color: #000000;
          letter-spacing: 0;
          line-height: 33px;
          font-weight: 400;
        }
      }
      .menu {
        position: absolute;
        top: 45px;
        left: -1px;
        width: 288px;
        max-height: 0;
        background: #ffffff;
        border: 1px solid #b4b4b4;
        border-top: none;
        border-bottom: none;
        overflow: hidden;
        transition: max-height 0.3s ease-in-out;
        &.active {
          max-height: 500px;
          border-bottom: 1px solid #b4b4b4;
          transition: max-height 0.3s ease-in-out;
        }
        &Inner {
          display: flex;
          flex-direction: column;
          height: fit-content;
          width: 288px;
          padding: 18.5px 18.5px 20.5px 23px;
          span {
            font-family: "GeogrotesqueSharp-Md";
            font-size: 13px;
            color: #000000;
            letter-spacing: 0;
            line-height: 33px;
            font-weight: 400;
            cursor: pointer;
          }
        }
      }
    }
    .terms_acceptance {
      width: 100%;
      font-size: 12px;
      margin-top: 20px;
      color: #a2a2a2;
      @include media-breakpoint-down(sm) {
        margin-top: 10px;
        font-size: 9px;
      }
    }
    .checks {
      display: flex;
      flex-direction: column;
      margin: 40px 0;
      h4 {
        color: black;
        font-size: 16px;
        font-family: "GeogrotesqueSharp-Md";
      }
      .check-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        @include media-breakpoint-down(sm) {
          align-items: baseline;
        }
        .box {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 17px;
          width: 17px;
          background: #ffffff;
          border: 1px solid #b4b4b4;
          margin-right: 14px;
          cursor: pointer;
          @include media-breakpoint-down(sm) {
            height: 15px;
            width: 20px;
          }
          &.active {
            img {
              opacity: 1;
              transition: opacity 0.2s ease-in-out;
            }
          }
          img {
            opacity: 0;
            transition: opacity 0.2s ease-in-out;
          }
        }
        span {
          font-family: "GeogrotesqueSharp-Md";
          font-size: 13px;
          color: #000000;
          letter-spacing: 0;
          line-height: 33px;
          font-weight: 400;
        }
      }
    }

    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 46px;
      width: 192px;
      background: theme-var($--ch-theme-secondary);
      border: 2px solid theme-var($--ch-theme-secondary);
      font-family: "GeogrotesqueSharp-Md";
      font-size: 22px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 700;
      text-transform: uppercase;
      margin: 0 auto;
      cursor: pointer;
      margin-top: 30px;

      transition: all 0.3s ease-in-out;
      @include media-breakpoint-down(sm) {
        margin-top: 15px;
        height: 26px;
        width: 132px;
        font-size: 14px;
      }
      &:hover {
        background: #ffffff;
        color: theme-var($--ch-theme-primary);
        border: 2px solid theme-var($--ch-theme-primary);
      }
    }
    .success {
      height: 100%;
      width: 100%;
      justify-content: center;
      align-items: center;
      font-family: "GeogrotesqueSharp-Bd";
      font-size: 22px;
      color: theme-var($--ch-theme-primary);
      letter-spacing: 0;
      text-align: center;
      font-weight: 700;
      flex-direction: column;
      // text-transform: uppercase;
      display: none;

      img {
        width: 300px;
        display: block;
        margin: 0 auto 50px;

        @include media-breakpoint-down(md) {
          width: 207px;
        }
      }

      p {
        max-width: 632px;
        font-size: 30px;
        font-weight: 600;
        line-height: 36px;
        color: white;
        font-family: Prompt;
        margin-bottom: 16px;

        @include media-breakpoint-down(md) {
          font-size: 24px;
          line-height: 30px;
        }
      }

      button {
        display: inline-block;
        text-transform: uppercase;
        text-align: center;
        width: auto;
        height: auto;
        font-family: Prompt;
        padding: 14px 24px 10px;
        font-size: 18px;
        line-height: normal;
        text-transform: uppercase;
        transition: all 0.2s linear;
        border-radius: 0;
        border: none;
        outline: none;
        transform: scale(1);
        background-color: transparent;
        font-weight: 700;
        color: white;
        border: 2px solid #f16924;
        cursor: pointer;
        margin: 20px auto 70px;

        &:hover {
          border: 2px solid white;
          background-color: #f16924;
        }
      }
      &.active {
        display: flex;
      }
    }
  }
}
</style>
